export var GooglePayEventsEnum;
(function (GooglePayEventsEnum) {
  GooglePayEventsEnum["Loaded"] = "googlePayLoaded";
  GooglePayEventsEnum["FailedToLoad"] = "googlePayFailedToLoad";
  GooglePayEventsEnum["Completed"] = "googlePayCompleted";
  GooglePayEventsEnum["Canceled"] = "googlePayCanceled";
  GooglePayEventsEnum["Failed"] = "googlePayFailed";
})(GooglePayEventsEnum || (GooglePayEventsEnum = {}));
